import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { AccessLogAdminService } from 'brain-data/service/access-log/access-log-admin.service';
import { loadAdminAccessLogs, loadAdminAccessLogsError, loadAdminAccessLogsSuccess } from '../actions/access-log.action';

@Injectable()
export class AccessLogEffects {
  loadAccessLogs$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadAdminAccessLogs),
      switchMap(({ query }) =>
        this.accessLogAdminService.getAccessLogs(query).pipe(
          map(page => loadAdminAccessLogsSuccess({ page })),
          catchError(error => of(loadAdminAccessLogsError({ error }))),
        ),
      ),
    );
  });

  constructor(
    private actions$: Actions,
    private accessLogAdminService: AccessLogAdminService,
  ) {}
}
